import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ModelWrapper } from "../../component/ModelWrapper";
import { SelectandContinue } from "./SelectandContinue";
import { FormattedMessage } from "react-intl";
import { getFiles } from "sr/utils/api/getFiles";
import { getFile } from "sr/utils/api/getFile";
import {
  BACKGROUND_CHECK_STATUSES,
  STRIPE_ONBOARDING_STATUSES,
} from "sr/constants/common";
export const CleanerProfileCard = ({ item, jobData, jobDraft }) => {
  const [profileImg, setProfileImg] = useState(null);
  const [model, setModel] = useState(false);
  const [jobId, setJobId] = useState<string>();
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [readMore, setReadMore] = useState(false);
  const activeJob = useMemo(() => jobData || jobDraft, [jobData, jobDraft]);
  const HandleModelByProps = (data: any) => {
    setModel(data);
  };
  const param = useParams();
  useEffect(() => {
    const fetchProfileImg = async (cleanerId) => {
      const params = {
        cleaner_id: cleanerId,
      };
      const profileImg = await getFiles(params);
      if (profileImg?.success === true) {
        const filterfile = profileImg?.data?.filter(
          (item) => item?.file?.fieldname === "profile_img",
        );
        if (filterfile && filterfile[0]?.file?.key) {
          const fileimg = await getFile(filterfile[0]?.file?.key);
          if (fileimg) {
            const newImageUrl = URL.createObjectURL(fileimg);
            setProfileImg(newImageUrl);
          }
        }
      }
    };
    if (item?._id) fetchProfileImg(item?._id);
  }, [item?._id]);

  useEffect(() => {
    const { jobid, to, from } = param;
    setJobId(jobid);
    setTo(to);
    setFrom(from);
  }, [param]);

  const description = useMemo(() => {
    return (
      item?.job_types?.find((jt: any) => jt?.job_type[0] === activeJob?.title)
        ?.additional_information || ""
    );
  }, [item, activeJob]);

  return (
    <>
      <div className="bg-white border border-neutral-200 rounded-lg mb-3 p-4 hover:shadow-sm transition">
        <div className="flex items-center gap-4">
          {/* Profile Image */}
          <img
            alt="Profile"
            className="w-20 h-20 rounded-full object-cover"
            src={
              profileImg
                ? profileImg
                : "/media/icons/displayProfilePlaceholder.png"
            }
          />

          {/* Right Content */}
          <div className="flex-1">
            {/* Top Row */}
            <div className="flex justify-between items-start">
              <div>
                <p className="text-base font-semibold flex gap-2 items-center">
                  {item?.first_name} {item?.last_name}
                  {((item?.backgroundCheckStatus != undefined &&
                    [
                      BACKGROUND_CHECK_STATUSES.CLEAR,
                      BACKGROUND_CHECK_STATUSES.CONSIDER,
                    ].indexOf(item?.backgroundCheckStatus) !== -1) ||
                    item?.stripe_customer_model?.stripe_onboarding_status ===
                      STRIPE_ONBOARDING_STATUSES.SUCCESS) && (
                      <span className="relative group w-6 h-6 inline">
                        <img
                          src="/media/icons/checkr-badge-pink-NB.png"
                          alt="Background check verified"
                          className="w-6 h-6"
                        />

                        {/* Tooltip */}
                        <div className="absolute left-0 top-full pt-2 w-52 hidden group-hover:block z-50">
                          <div className="bg-gray-900 text-white text-xs rounded-lg p-3 shadow-lg leading-relaxed">
                            Background Check Verified User
                          </div>
                        </div>
                      </span>
                    )}
                </p>

                <div className="flex items-center gap-1 text-xs text-gray-500 mt-1">
                  ⭐ {item?.rating?.avgExternalRating?.toFixed(1)}
                  <span>({item?.rating?.totalReviews} reviews)</span>
                </div>
              </div>

              <p className="text-sm font-semibold text-gray-800">
                $
                {item?.job_types
                  ?.find((jt) => jt?.job_type[0] === activeJob?.title)
                  ?.rate?.toFixed(2)}
                /hr
              </p>
            </div>

            {/* Actions */}
            <div className="flex justify-between items-center mt-3">
              <Link
                to={`/individual/cleaner-profile-details/${item?.id}/${jobId}/${from}/${to}`}
                state={jobId === "draft" && jobDraft ? { jobDraft } : undefined}
                className="text-sm text-[#0078ae] hover:underline"
              >
                View Profile and Reviews
              </Link>

              <button
                onClick={() => setModel(true)}
                className="text-sm bg-[#ff39b3] text-white px-4 py-1.5 rounded-full hover:bg-[#e632a3] transition"
              >
                Select and Continue
              </button>
            </div>

            {/* Subtle helper text */}
            <p className="text-[11px] text-gray-400 mt-2 leading-snug">
              You can chat with your cleaner, adjust job details, or change the
              job time after booking.
            </p>
          </div>
        </div>
      </div>
      {model && (
        <ModelWrapper
          showModal={model}
          background="bg-[#00000099]"
          opacity="opacity-100"
          topPosition="top-[10%]"
          rightPosition="inset-0"
          HandleModelByProps={HandleModelByProps}
          width="w-[50%] mx-auto"
          position="fixed"
          topClass="flex w-full"
        >
          <SelectandContinue
            setModel={setModel}
            item={item}
            profileImg={profileImg}
            jobData={jobData}
            jobDraft={jobDraft}
          ></SelectandContinue>
        </ModelWrapper>
      )}
    </>
  );
};
